
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy, Input, AfterContentChecked } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { GeneralService } from '../../services/general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { AppLoadingService } from '../../services/apploading.service';
import { AbstractForm } from '../../utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { Subscription } from 'rxjs';
import { Address } from '../../models/address';
import { City } from '../../models/city';
import { MatDialogRef } from '@angular/material/dialog';
import { Document } from '../../models/document';

declare var $: any;

@Component({
  selector: 'myprofile',
  templateUrl: './myprofile.component.html',
  styleUrls: ['./myprofile.component.scss']
})
export class MyProfileComponent extends AbstractForm implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {

  @ViewChild('btnFile', { static: false }) btnFile: ElementRef;
  @ViewChild('btnCamera', { static: false }) btnCamera: ElementRef;

  @Input() state: any = '';

  params: any = {};

  minPw = 8;
  formGroup: FormGroup;
  helpFormGroup: FormGroup;
  preferencesFormGroup: FormGroup;
  formGroupDelete: FormGroup;
  infoFormGroup: FormGroup;
  infoForm: AbstractForm[] = [];
  infoFormArry: FormArray;

  fileLoaded = false;
  loading = true;
  submitted = false;
  states: [] = [];

  avatar: any = [];
  avatarFile: any;
  personData: any = [];

  cities: any = [];
  citiesLoaded = false;
  citiesSelected: any = [];

  feedbackSended = false;
  userAllow = false;

  userdata: any = {};

  tabActive = 'info';

  protected personDataSubscription: Subscription;
  protected avatarSubscription: Subscription;

  constructor(
    public gs: GeneralService,
    protected httpService: HttpService,
    logger: LoggerService,
    private auth: AuthService,
    protected als: AppLoadingService,
    protected formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<MyProfileComponent>) {
    super(formBuilder, logger);



  }

  getUserdata() {
    return this.auth.getUserdata();
  }

  ngOnInit() {

    if (this.params?.tab)
      this.tabActive = this.params.tab;

    this.formGroupDelete = this.formBuilder.group({
      deletePhrase: ['', [Validators.minLength(19), Validators.maxLength(19), Validators.required]],
      cityInterest: this.formBuilder.group({})
    });

    this.preferencesFormGroup = this.formBuilder.group({
      cityMain: ['', [Validators.required]],
      cityInterest: this.formBuilder.group({})
    });

    this.infoFormGroup = this.formBuilder.group({
      person_type: { value: '', disabled: true },
      birthday: [''],
      company_name: [''],
      site: [''],
      instagram: [''],
      facebook: [''],
      tiktok: [''],
      youtube: [''],
      twitter: [''],
      linkedin: [''],

      phone: [''],
      cellphone: { value: '', disabled: true },
      email: { value: '', disabled: true },
      document: ['', [Validators.minLength(11), Document.validate('cpf')]],
      creci_code: { value: '', disabled: true },
      creci_state_id: { value: '', disabled: true },
    });

    this.personDataSubscription = this.gs.generalData$.subscribe((result) => {
      if (!!result?.person?.length) {
        this.personData = result?.person[0];
        this.states = result?.states;
        this.avatar = this.gs.setAvatarFile();
        this.setInfoData();
        this.fileLoaded = true;


      }
    });
    this.avatarSubscription = this.gs.avatar$.subscribe((result) => {
      this.avatarFile = result.thumb;
    });

    this.userdata = this.getUserdata();
    this.userAllow = this.gs.getSignUpState() == 'AccessAllow';

    let passRequirement = {
      passwordMinLowerCase: 1,
      passwordMinNumber: 1,
      passwordMinSymbol: 0,
      passwordMinUpperCase: 0,
      passwordMinCharacters: 8
    };
    let pattern = [
      `(?=([^a-z]*[a-z])\{${passRequirement.passwordMinLowerCase},\})`,
      `(?=([^A-Z]*[A-Z])\{${passRequirement.passwordMinUpperCase},\})`,
      `(?=([^0-9]*[0-9])\{${passRequirement.passwordMinNumber},\})`,
      `(?=(\.\*[\$\@\$\!\%\*\?\&])\{${passRequirement.passwordMinSymbol},\})`,
      `[A-Za-z\\d\$\@\$\!\%\*\?\&\.]{${passRequirement.passwordMinCharacters},}`
    ]
      .map(item => item.toString())
      .join("");

    let pwdValidator = Validators.pattern(pattern);

    this.formGroup = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
      password2: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]]
    });
  }

  ngOnDestroy() {
    this.personDataSubscription.unsubscribe();
    this.avatarSubscription.unsubscribe();
  }

  ngAfterViewInit() {
  }
  ngAfterContentChecked() {
    this.setTooltip();
    this.loading = false;
  }
  setTooltip() {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
  }

  compareFn(c1: any, c2: any): boolean {
    if (c2 === null)
      return false;

    return c1?.id == c2?.id || c1?.id == c2 || c1 == c2?.id;
  }

  avatarChange(ev) {
    if (!!ev?.length)
      this.gs.avatarChange(ev);

  }



  updateControls() { }
  updateObject(): any { }

  getSectionImageUrl() {
    return this.gs.buildImagemUrl('section-art4.png');
  }

  onSubmitDelete() {
    if (this.formGroupDelete.invalid)
      return this.gs.error({}, 'Preencha corretamente os campos');

    const phrase = this.getControlValue('deletePhrase', this.formGroupDelete);

    if (phrase != 'excluir minha conta')
      return this.gs.error({}, 'Preencha corretamente os campos');


    this.httpService.post<any>(API.profile.general.anonymize,{})
      .then(result => {
        this.gs.error({}, 'Conta excluída com sucesso');
        this.auth.signOut();
        this.gs.authChecked.next(true);
      })
      .catch((err) => this.gs.error(err))
      ;

  }

  onSubmit() {

    if (this.formGroup.invalid)
      return this.gs.error({}, 'Preencha corretamente os campos');

    this.auth.getCurrentUser().then(user => {
      this.submitted = true;

      if (!user?.signInUserSession?.idToken?.jwtToken || !user?.attributes?.email) {
        this.submitted = false;
        return this.gs.error({}, 'Usuário inválido');
      }

      this.als.setLoaded(false, 'profile');
      this.httpService.post<any>(API.profile.general.password, { new: this.getControlValue('password2'), old: this.getControlValue('password'), token: user.signInUserSession.accessToken.jwtToken })
        .then(result => {
          this.gs.error({}, 'Senha alterada com sucesso');
        })
        .catch((err) => this.gs.error(err))
        .finally(() => {
          this.submitted = false;
          this.als.setLoaded(true, 'profile');
        });
    });
  }

  getFileAvatar(arr) {
    if (!arr.length || !arr[arr.length - 1]?.variations)
      return false;

    return this.gs.getFileName(arr[arr.length - 1], 'thumb');
  }


  /*
      PERSON DATA
  */

  setInfoData() {

    let city = new City();
    city.id = this.personData.address_city_id;
    city.name = this.personData.address_city_name;
    city.state = this.personData.address_state_id;

    this.personData.address = new Address(
      '',
      this.personData.address_zipcode,
      city,
      this.personData.address_street,
      this.personData.address_number,
      this.personData.address_complement,
      this.personData.address_district,
      this.personData.address_latitude,
      this.personData.address_longitude,
      0);
    Object.entries(this.infoFormGroup.controls).forEach(([k, v]) => {
      let vl = this.personData[k] || '';

      if (k == 'birthday' && vl.length > 9)
        vl = new Date(vl + ' 00:00:01').toLocaleDateString();
      this.setControlValue(k, vl, this.infoFormGroup);
      this.getControl(k, this.infoFormGroup).markAsPristine();
    });
  }

  phoneMethod(event, field) {
    switch (event.type) {
      case 'focus':
        if (!this.getControlValue(field, this.infoFormGroup))
          this.setControlValue(field, '55', this.infoFormGroup);
        break;
      case 'blur':
        if (this.getControlValue(field, this.infoFormGroup) == '55')
          this.setControlValue(field, null, this.infoFormGroup);
        break;
    }
  }

  receiveEvent(form: AbstractForm | any): void {
    if (form instanceof AbstractForm) {
      this.infoForm.push(form);
    } else if (form == 'dirty') {
      this.infoFormGroup.markAsDirty();
    }
  }

  sendInfo() {

    let values: any = this.getFormValues(this.infoFormGroup, true, true);
    let address = this.getFormValues(this.infoForm[0].formGroup, true, true);
    if (!!Object.keys(address).length)
      values.address = address;

    if (!Object.keys(values).length)
      return;

    this.als.setLoaded(false, 'profile');

    this.httpService.put<any>(API.profile.general.base, values)
      .then(result => {
        this.gs.error({}, 'Operação concluída');
        this.gs.doConfirmSignedIn(null);
      })
      .catch((err) => this.gs.error(err))
      .finally(() => {
        this.als.setLoaded(true, 'profile');
      });
  }

}
